import React from 'react'
import { connect } from 'react-redux'
import { Router, Route, Switch } from 'react-router-dom'
import history from './history'
import ScrollToTop from './ScrollToTop'
/*************
    Auth
*************/
import AuthRoute from './AuthRoute'
/*************
    LayOut
*************/
import DefaultLayout from '../layout/DefaultLayout'
import NonLayout from '../layout/NonLayout'
// import ServiceLayout from '../layout/ServiceLayout'
// import ServiceNewLayout from '../layout/ServiceNewLayout'
/*************
   Component
 *************/
import Index from '../component/home/index'
import notify from '../component/home/notify'
import Setting from '../component/home/Setting'
import PushInfo from '../component/home/PushInfo'
import ApplyInfo from '../component/home/ApplyInfo'
import InboxInfo from '../component/home/InboxInfo'
import SentInfo from '../component/home/SentInfo'
import RNListener from '../component/home/RNListener'
import Notice from '../component/board/Notice'
import Faq from '../component/board/Faq'
import Question from '../component/board/Question'
import Reference from '../component/board/Reference'
import Guide from '../component/board/Guide'
import QuestionWrite from '../component/board/QuestionWrite'
/*************
 LogIn/signUp
*************/
import Login from '../component/home/login/Login'
// import Join from '../component/home/regis/join2-ori'
import Join from '../component/home/regis/join2'
import RegisStep0 from '../component/home/regis/RegisStep0'
import RegisSimpleStep0 from '../component/home/regis/RegisSimpleStep0'
// import RegisStep1 from '../component/home/regis/RegisStep1'
// import RegisStep2 from '../component/home/regis/RegisStep2'
// import RegisUser from '../component/home/regis/RegisCompany-ori' // 기존 개인 회원가입
import RegisUserStep1 from '../component/home/regis/RegisUserStep1'
import RegisUserStep2 from '../component/home/regis/RegisUserStep2'
import RegisUserStep3 from '../component/home/regis/RegisUserStep3'
import RegisManager from '../component/home/regis/RegisCompany'
import DuplicateJoinInfo from '../component/home/regis/DuplicateJoinInfo'
import RegisSimplePreTitle from "../component/home/regis/RegisSimplePreTitle"
import RegisSimpleTitle from '../component/home/regis/RegisSimpleTitle'
import RegisSimpleInput from '../component/home/regis/RegisSimpleInput'
import RegisSimpleComplete from '../component/home/regis/RegisSimpleComplete'
import RegisSimpleCompanyUser from '../component/home/regis/RegisSimpleCompany' // 연계관련 기업 간편회원가입
import RegisAgreeSimpleCompanyUser from '../component/home/regis/RegisAgreeSimpleCompany' // 연계관련 기업 간편회원가입
import RegisSuccess from '../component/home/regis/RegisSuccess'
import FindId from '../component/home/login/FindId'
import FindPass from '../component/home/login/FindPass'
import ChangeInfo from '../component/home/info/ChangeInfo'
import ChangePass from '../component/home/info/ChangePass'
import Retire from '../component/home/info/Retire'
import FindPassTerm from '../component/home/login/FindPassTerm'
import LoginPass from '../component/home/login/LoginPass'
import LoginPassReset from '../component/home/login/LoginPassReset'
// import CompanyInfo from '../component/home/info/CompanyInfo'
// import CompanyUsers from '../component/home/info/CompanyUsers'
import InviteList from '../component/home/company/InviteList'
import ManageInfo from '../component/home/company/ManageInfo'
import LoginIntro from '../component/home/login/LoginIntro'
import LoginCorp from '../component/home/login/LoginCorp'
import PasswordConfirmModal from '../component/home/PasswordConfirmModal'
/*************
   Service
*************/
import CertificateApplyDetail from '../component/service/certificate/apply/CertificateApplyDetail'
import CertificateApply from '../component/service/certificate/apply/CertificateApply'
import CertMngDetail from '../component/service/certificate/certmng/CertMngDetail'
import CertMng from '../component/service/certificate/certmng/CertMng'
import CertIssue from '../component/service/certificate/certissue/CertIssue'
import CertIssueDetail from '../component/service/certificate/certissue/CertIssueDetail'
import BundleDetail from '../component/service/certificate/bundle/BundleDetail'
import Bundle from '../component/service/certificate/bundle/Bundle'
import CertApplyDetail from '../component/service/certificate/apply/CertApplyDetail'
import CertApply from '../component/service/certificate/apply/CertApply'
import Certbox from '../component/service/certificate/certbox/Certbox'
import CertboxDetail from '../component/service/certificate/certbox/CertboxDetail'
import CertboxSubmit from '../component/service/certificate/certbox/CertboxSubmit'
import CertificateInbox from '../component/service/certificate/inbox/CertificateInbox'
import CertificateInboxDetail from '../component/service/certificate/inbox/CertificateDetail'
import CertificateInboxSubmit from '../component/service/certificate/inbox/CertificateSubmit'
/* import CertificateSent from '../component/service/certificate/sent/CertificateSent' */
import CertificateSentDetail from '../component/service/certificate/sent/CertificateSentDetail'
import CertificateVerify from '../component/service/certificate/verify/CertificateVerify'
import CertificateVerifyNotMember from '../component/service/certificate/verify/CertificateVerifyNotMember'
import CertificateInboxOrigin from '../component/service/certificate/CertificateInboxOrigin'
import CertboxReading from '../component/service/certificate/certbox/CertboxReading'
import EfDocument from '../component/service/certificate/offical/EfDocument'
import CertificateSentMain from '../component/service/certificate/sent/CertificateSentMain'
/** 정부전자문서지갑 */
import GovEDocWallet from '../component/service/certificate/govdoc/GovEDocWallet'
import GovEDocApplyDrivers from '../component/service/certificate/govdoc/GovEDocApplyDrivers'
import GovEDocApplyBusiness from '../component/service/certificate/govdoc/GovEDocApplyBusiness'
/*************
 Mobile
 *************/
import MobileGuide from '../component/home/mobile/MobileGuide'
import MobileMain from '../component/home/mobile/MobileMain'
import MobileNotification from '../component/home/mobile/MobileNotification'
/*************
     404
*************/
import NotFound from '../component/home/NotFound'
import Terms from '../component/home/terms'
import Privacy from '../component/home/privacy'
import PdfViewer from '../component/service/certificate/PdfViewer'
import OpenLink from '../component/home/OpenLink'
/*************
    참고용: UI Components
*************/
import UICase from '../component/home/UICase'
/** 20220418 이원재 snsn 로그인 등록*/
import ChangeLogin from '../component/home/info/ChangeLogin'
import OAuth2RedirectHandler from '../component/oauth/OAuth2RedirectHandler'
import OAuth2RedirectHandlerNaver from '../component/oauth/OAuth2RedirectHandlerNaver'
import OAuth2RedirectHandlerOnePass from '../component/oauth/OAuth2RedirectHandlerOnePass'
/** 공동인증서 관리 */
import CrtfctManagement from '../component/home/crtfct/CrtfctManagement'
import CrtfctManagementMobile from '../component/home/crtfct/CrtfctManagementMobile'
import CrtfctStepMobile01 from '../component/home/crtfct/CrtfctStepMobile01'
import CrtfctStepMobile02 from '../component/home/crtfct/CrtfctStepMobile02'
import { authActions } from '../store/actions'
import ChempRcvCertbox from "../component/service/certificate/certbox/chemp/ChempRcvCertbox";
import ChempSndCertbox from "../component/service/certificate/certbox/chemp/ChempSndCertbox";


const Routes = ({ auth }) => {
  return (
    <Router history={history}>
      <RNListener />
      <ScrollToTop />
      <Switch>
        {/***********
            default
         ***********/}
        <Route
          exact
          path={[
            '/login',
            '/find/id',
            '/find/pass',
            '/regis/Join',
            '/regis/Join/:from',
            '/regis',
            // '/regis/corp',
            '/regis/user',
            // '/regis/RegisStep2',
            '/regis/RegisUserStep2',
            '/regis/RegisUserStep3/:memberId',
            '/regis/manager',
            '/regis/duplicateJoinInfo',
            '/regis/simple',
            '/regis/simpleCompany/:groupName/:groupRegistno/:memberName/:mobileNo',
            '/regis/simpleCompany/:groupName/:groupRegistno/:memberName/:mobileNo/:email',
            '/regis/simpleCompany',
            '/regis/success/:memberId',
            '/FindPassTerm',
            '/LoginPass',
            '/LoginPassReset',
            '/change/info',
            '/change/pass',
            '/company/info',
            '/company/invite',
            '/applyinfo',
            '/inboxinfo',
            '/sentinfo',
            '/terms',
            '/privacy',
            '/essentialPrivacy',
            '/optionalPrivacy',
            '/notice',
            '/notice/:seq',
            '/faq',
            '/question',
            '/question/:seq',
            '/questionwrite',
            '/reference',
            '/reference/:seq',
            '/guide',
            '/retire',
            /****** MOBILE ******/
            '/mobile/notification',
            '/mobile/main',
            // '/mobile/guide',
            /****** 참고용: UI Components ******/
            '/uicase',
            /** 20220418 이원재 sns 로그인 등록*/
            '/change/login',
            '/oauth/callback/kakao',
            '/oauth/callback/naver',
            '/oauth/callback/onepass',
            /**인증서 관리 */
            '/crtfct/mng',
            '/crtfct/mngMobile',
            '/crtfct/mngMobile/CrtfctStepMobile01',
            '/crtfct/mngMobile/CrtfctStepMobile02',
            /**증명서 1회열람 */
            '/service/certread/:onetmPrslCntnTocken',
            /**로그인 인트로 */
            '/loginIntro',
            '/loginCorp',
            '/passwordConfirmModal',
            /******* 기존에 있던 service 하나로 합침 - 2022-05-27(기존 소스는 index-ori.js에 있음) *******/
            '/',
            '/service/notify',
            '/service/PushInfo',
            '/service/Setting',
            '/service/certapply/detail/:seq',
            '/service/certapply/:step',
            '/service/certbox',
            '/service/certbox/detail/:seq',
            '/service/certbox/submit',
            '/service/certmng/detail/:seq',
            '/service/certmng',
            '/service/certissue',
            '/service/certissue/detail/:seq',
            '/service/bundle/detail/:seq',
            '/service/bundle',
            '/service/issuance/document',
            '/service/gov/edocwallet',
            '/service/gov/edocwallet/drivers',
            '/service/gov/edocwallet/business',
            '/service/offical/EfDocument',
            /******* 기존 as-is 소스코드 - 2022-05-27(기존 소스는 index-ori.js에 있음) *******/
            '/service',
            '/service/apply/detail/:seq',
            '/service/apply/:step',
            '/service/inbox',
            '/service/inbox/detail/:seq',
            '/service/inbox/submit',
            '/service/inbox/origin',
            '/service/sent',
            '/service/sent/detail/:seq',
            '/service/sent/origin',
            '/service/verify',
            '/service/verify/nm',
            '/service/certbox/chemp',
            '/service/certbox/chemp/sendbox'
            // '/test',
          ]}
        >
          <DefaultLayout>
            <Switch>
              {/********** 회원가입/로그인 공통레이아웃적용:0623 **********/}
              <Route exact path="/login" component={Login} />
              <Route exact path="/find/id" component={FindId} />
              <Route exact path="/find/pass" component={FindPass} />
              <Route exact path="/regis/Join" component={Join} />
              <Route exact path="/regis/Join/:from" component={Join} />
              <Route exact path="/regis" component={RegisStep0} />
                <Route exact path="/regis/simple" component={RegisSimpleStep0} />
                {/* <Route exact path="/regis/corp" component={RegisStep0} /> */}
              {/* <Route exact path="/regis/user" component={RegisUser} /> */} {/* 기존 개인 회원가입 */}
              {/* <Route exact path="/regis/RegisStep2" component={RegisStep2} /> */}
              <Route exact path="/regis/user" component={RegisUserStep1} /> {/** 개인 회원가입 - 본인인증 */}
              <Route exact path="/regis/RegisUserStep2" component={RegisUserStep2} /> {/** 개인 회원가입 - 회원정보 입력 */}
              <Route exact path="/regis/RegisUserStep3/:memberId" component={RegisUserStep3} /> {/** 개인 회원가입 - 가입완료 */}
              <Route exact path="/regis/manager" component={RegisManager} /> {/* 법인 회원가입 - 사업자/담당자정보 */}
              <Route exact path="/regis/duplicateJoinInfo" component={DuplicateJoinInfo} />
              <Route exact path="/regis/simpleCompany/:groupName/:groupRegistno/:memberName/:mobileNo/:email" component={RegisSimpleCompanyUser} /> {/* 법인 간편 회원가입 */}
              <Route exact path="/regis/simpleCompany/:groupName/:groupRegistno/:memberName/:mobileNo" component={RegisSimpleCompanyUser} /> {/* 법인 간편 회원가입 */}
              <Route exact path="/regis/simpleCompany" component={RegisAgreeSimpleCompanyUser} /> {/* 법인 간편 회원가입 */}
              <Route exact path="/regis/success/:memberId" component={RegisSuccess} /> {/* 법인 회원가입 - 가입완료 */}
              <Route exact path="/FindPassTerm" component={FindPassTerm} />
              <Route exact path="/LoginPass" component={LoginPass} />
              <Route exact path="/LoginPassReset" component={LoginPassReset} />
              <Route exact path="/applyinfo" component={ApplyInfo} />
              <Route exact path="/inboxinfo" component={InboxInfo} />
              <Route exact path="/sentinfo" component={SentInfo} />
              <Route exact path="/terms" component={Terms} />
              <Route exact path="/privacy" component={Privacy} />
                {/*<Route exact path="/privacy" component={EssentialPrivacy} />*/}
                {/*<Route exact path="/privacy" component={OptioanlPrivacy} />*/}
              <Route exact path="/notice" component={Notice} />
              <Route exact path="/notice/:seq" component={Notice} />
              <Route exact path="/faq" component={Faq} />
              <Route exact path="/question" component={Question} />
              <Route exact path="/question/:seq" component={Question} />
              <AuthRoute exact path="/questionwrite" component={QuestionWrite} auth={auth} />
              <Route exact path="/reference" component={Reference} />
              <Route exact path="/reference/:seq" component={Reference} />
              <Route exact path="/guide" component={Guide} />
              <AuthRoute exact path="/change/info" component={ChangeInfo} auth={auth} />
              <AuthRoute exact path="/change/pass" component={ChangePass} auth={auth} />
              <AuthRoute exact path="/company/info" component={ManageInfo} auth={auth} />
              <AuthRoute exact path="/company/invite" component={InviteList} auth={auth} />
              <AuthRoute exact path="/retire" component={Retire} auth={auth} />
              {/********** 모바일 **********/}
              <AuthRoute exact path="/mobile/main" component={MobileMain} auth={auth} />
              <AuthRoute exact path="/mobile/notification" component={MobileNotification} auth={auth} />
              {/********** 참고용: UI Components **********/}
              <Route exact path="/uicase" component={UICase} />
              {/** 20220418 이원재 sns 로그인 등록*/}
              <AuthRoute exact path="/change/login" component={ChangeLogin} auth={auth} />
              <Route exact path="/oauth/callback/kakao" component={OAuth2RedirectHandler} />
              <Route exact path="/oauth/callback/naver" component={OAuth2RedirectHandlerNaver} />
              <Route exact path="/oauth/callback/onepass" component={OAuth2RedirectHandlerOnePass} />
              {/** 20220427 이원재 인증서관리 등록*/}
              <Route exact path="/crtfct/mng" component={CrtfctManagement} />
              <Route exact path="/crtfct/mngMobile" component={CrtfctManagementMobile} />
              <Route exact path="/crtfct/mngMobile/CrtfctStepMobile01" component={CrtfctStepMobile01} />
              <Route exact path="/crtfct/mngMobile/CrtfctStepMobile02" component={CrtfctStepMobile02} />
              {/** 20220520 김은상 증명서 1회 열람*/}
              <Route exact path="/service/certread/:onetmPrslCntnTocken" component={CertboxReading} />
              {/**로그인 인트로 */}
              <Route exact path="/loginIntro" component={LoginIntro} />
              <Route exact path="/loginCorp" component={LoginCorp} />
              <Route exact path="/passwordConfirmModal" component={PasswordConfirmModal} />
              {/******* 기존에 있던 service 하나로 합침 - 2022-05-27(기존 소스는 index-ori.js에 있음) *******/}
              <Route exact path="/" component={Index} />
              <AuthRoute exact path="/service/notify" component={notify} auth={auth} />
              <AuthRoute exact path="/service/PushInfo" component={PushInfo} auth={auth} />
              <AuthRoute exact path="/service/Setting" component={Setting} auth={auth} />
              <AuthRoute exact path="/service/certapply/detail/:seq" component={CertApplyDetail} auth={auth} />
              <AuthRoute exact path="/service/certapply/:step" component={CertApply} auth={auth} />
              <AuthRoute exact path="/service/certbox" component={Certbox} auth={auth} />
              <AuthRoute exact path="/service/certbox/detail/:seq" component={CertboxDetail} auth={auth} />
              <AuthRoute exact path="/service/certbox/submit" component={CertboxSubmit} auth={auth} />
              <AuthRoute exact path="/service/certmng/detail/:seq" component={CertMngDetail} auth={auth} />
              <AuthRoute exact path="/service/certmng" component={CertMng} auth={auth} />
              <AuthRoute exact path="/service/certissue" component={CertIssue} auth={auth} />
              <AuthRoute exact path="/service/certissue/detail/:seq" component={CertIssueDetail} auth={auth} />
              <AuthRoute exact path="/service/bundle/detail/:seq" component={BundleDetail} auth={auth} />
              <AuthRoute exact path="/service/bundle" component={Bundle} auth={auth} />
              {/* 정부전자문서지갑 커스텀 - 2022-06-14 박유석 */}
              <AuthRoute exact path="/service/gov/edocwallet" component={GovEDocWallet} auth={auth} />
              {/* 정부전자문서지갑 운정자경력증명 신청하기 커스텀 - 2022-06-15 박유석 */}
              <AuthRoute exact path="/service/gov/edocwallet/drivers" component={GovEDocApplyDrivers} auth={auth} />
              {/* 정부전자문서지갑 사업자등록증명 신청하기 커스텀 - 2022-06-16 박유석 */}
              <AuthRoute exact path="/service/gov/edocwallet/business" component={GovEDocApplyBusiness} auth={auth} />
              {/* 공인전자문서 2022-05-20 추가 */}
              <AuthRoute exact path="/service/offical/EfDocument" component={EfDocument} auth={auth} />
              {/* 보낸문서 추가*/}
              <AuthRoute exact path="/service/sent" component={CertificateSentMain} auth={auth} />
              {/******* 기존 as-is 소스코드 - 2022-05-27(기존 소스는 index-ori.js에 있음) *******/}
              <Route exact path="/service" component={CertificateInbox} />
              <AuthRoute exact path="/service/inbox" component={CertificateInbox} auth={auth} />
              <AuthRoute exact path="/service/inbox/detail/:seq" component={CertificateInboxDetail} auth={auth} />
              <AuthRoute exact path="/service/inbox/submit" component={CertificateInboxSubmit} auth={auth} />
              <Route exact path="/service/inbox/origin" component={CertificateInboxOrigin} />
              {/* <AuthRoute exact path="/service/sent" component={CertificateSent} auth={auth} /> */}
              <AuthRoute exact path="/service/sent/detail/:seq" component={CertificateSentDetail} auth={auth} />
              <AuthRoute exact path="/service/apply/detail/:seq" component={CertificateApplyDetail} auth={auth} />
              <AuthRoute exact path="/service/apply/:step" component={CertificateApply} auth={auth} />
              <AuthRoute exact path="/service/verify" component={CertificateVerify} auth={auth} />
              <Route exact path="/service/verify/nm" component={CertificateVerifyNotMember} />
              {/* <Route exact path="/test" component={redirectKclIndex} /> */}
              {/* 화학제품관리시스템 문서 목록 관리 화면 */}
              <AuthRoute exact path="/service/certbox/chemp" component={ChempRcvCertbox} auth={auth} />
              <AuthRoute exact path="/service/certbox/chemp/sendbox" component={ChempSndCertbox} auth={auth} />
            </Switch>
          </DefaultLayout>
        </Route>
      {/***********
       연계 간편회원가입 모바일
       ***********/}
      <Route path={[
          '/regis/simple/:groupName/:groupRegistno/:memberName/:mobileNo/:bplc',
          '/regis/simple/:groupName/:groupRegistno/:memberName/:mobileNo/:bplc/:email',
          '/regis/simpleTitle',
          '/regis/simpleInput',
          '/regis/simpleComplete'
      ]} exact>
          <NonLayout>
              <Switch>
                  <Route exact path="/regis/simple/:groupName/:groupRegistno/:memberName/:mobileNo/:bplcCd" component={RegisSimplePreTitle} /> {/* 법인 간편 회원가입 */}
                  <Route exact path="/regis/simple/:groupName/:groupRegistno/:memberName/:mobileNo/:bplcCd/:email" component={RegisSimplePreTitle} /> {/* 법인 간편 회원가입 */}
                  <Route exact path="/regis/simpleTitle" component={RegisSimpleTitle} /> {/* 법인 간편 회원가입 */}
                  <Route exact path="/regis/simpleInput" component={RegisSimpleInput} /> {/* 법인 간편 회원가입 */}
                  <Route exact path="/regis/simpleComplete" component={RegisSimpleComplete} /> {/* 법인 간편 회원가입 */}
              </Switch>
          </NonLayout>
      </Route>
        {/***********
          LogIn/signUp
        ***********/}
        <Route exact path="/pdf/:fileId" component={PdfViewer} />
        <Route exact path="/mobile/guide" component={MobileGuide} />
        <Route exact path="/openLink" component={OpenLink} />

        {/*** KCL페이지 redirection ***/}
        <Route exact path="/gate_html/kclIndex.html" render={() => {window.location.href="/gate_html/kclIndex.html"}} />
        <Route exact path="/kcl" render={() => {window.location.href="/gate_html/kclIndex.html"}} />
          {/*** KCL 중 기업연계 기관 redirection --- homeplus ***/}
          <Route exact path="/gate_html/homeplusIndex.html" render={() => {window.location.href="/gate_html/homeplusIndex.html"}} />
          <Route exact path="/homeplus" render={() => {window.location.href="/gate_html/homeplusIndex.html"}} />
          {/*** KCL 중 기업연계 기관 redirection --- lottemart ***/}
          <Route exact path="/gate_html/lottemartIndex.html" render={() => {window.location.href="/gate_html/lottemartIndex.html"}} />
          <Route exact path="/lottemart" render={() => {window.location.href="/gate_html/lottemartIndex.html"}} />
        {/*** KATRI 페이지 redirection ***/}
        <Route exact path="/gate_html/katriIndex.html" render={() => {window.location.href="/gate_html/katriIndex.html"}} />
        <Route exact path="/katri" render={() => {window.location.href="/gate_html/katriIndex.html"}} />
        {/*** KTR 페이지 redirection ***/}
        <Route exact path="/gate_html/ktrIndex.html" render={() => {window.location.href="/gate_html/ktrIndex.html"}} />
        <Route exact path="/ktr" render={() => {window.location.href="/gate_html/ktrIndex.html"}} />
        {/*** KTC 페이지 redirection ***/}
        <Route exact path="/gate_html/ktcIndex.html" render={() => {window.location.href="/gate_html/ktcIndex.html"}} />
        <Route exact path="/ktc" render={() => {window.location.href="/gate_html/ktcIndex.html"}} />
        {/* <Route exact path="/ttt"  component={authActions.logInCorp('opendoor','1234')} /> */}


          {/***********
           path : * 이면 모든 경로가 포함되기 때문에
           무조건 제일 밑!
           (우선순위 : 순차적으로 탐지하면서 걸리면 실행)
           404
           ***********/}
          <Route path="*" component={NotFound} />

      </Switch>
    </Router>
  )
}
const mapStateToProps = (state) => {
  return { auth: state.auth }
}
export default connect(mapStateToProps)(Routes)
